const MODERATION_CHURNED_CONTINUE_KEY = "mytour.moderation.churned-continue";

/**
 * sessionStorage (pas de state React) pour survivre à la navigation vers /.
 * Scopé par companyId : un login-as ultérieur sur une autre société en
 * veille, dans le même onglet, ne doit pas hériter du bypass.
 * Accès try/catchés : le storage peut lever en navigation privée Safari.
 */
export function markModerationChurnedContinue(companyId: string): void {
  try {
    sessionStorage.setItem(MODERATION_CHURNED_CONTINUE_KEY, companyId);
  } catch {
    // Storage indisponible — le support revoit l'écran de veille, rien de cassé.
  }
}

export function hasModerationChurnedContinue(companyId: string): boolean {
  try {
    return sessionStorage.getItem(MODERATION_CHURNED_CONTINUE_KEY) === companyId;
  } catch {
    return false;
  }
}
